import { render, staticRenderFns } from "./StakingCalculator.vue?vue&type=template&id=53979cf0&scoped=true&"
import script from "./StakingCalculator.vue?vue&type=script&lang=js&"
export * from "./StakingCalculator.vue?vue&type=script&lang=js&"
import style0 from "./StakingCalculator.vue?vue&type=style&index=0&id=53979cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53979cf0",
  null
  
)

export default component.exports